import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed } from 'vue';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
import { PRODUCT_CARDS_CAROUSEL_SLIDES_AMOUNT } from '~/constants';
import { ProductKeys } from '~/types/ProductEnums';
import { filterProducts } from '~/utils/commercetools/products';
export function useRelatedProductsStore() {
  var route = useRoute();
  var slug = route.params.slug;
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    country = _useLocalization.country,
    currency = _useLocalization.currency;

  /**
   * An array of transformed product models retrieved from Commercetools. This holds all related products, including masters and non-master variants.
   */
  var relatedProducts = useState("related-products-".concat(slug), function () {
    return [];
  });

  /**
   * This computed property filters and transforms the relatedProducts state to present a suitable list for display.
   */
  var availableRelatedProducts = computed(function () {
    var notMasterVariants = filterProducts(relatedProducts.value, {
      master: false
    });
    var productsWithVariants = filterProducts(relatedProducts.value, {
      master: true
    }).flatMap(function (product) {
      return [_objectSpread(_objectSpread({}, product), {}, {
        variants: notMasterVariants.filter(function (variant) {
          var _variant$attributesRa, _sellableAttribute$va;
          if (variant._id !== product._id) return false;
          var sellableAttribute = (_variant$attributesRa = variant.attributesRaw) === null || _variant$attributesRa === void 0 ? void 0 : _variant$attributesRa.find(function (attribute) {
            return attribute.name === ProductKeys.isSellable;
          });
          return (sellableAttribute === null || sellableAttribute === void 0 ? void 0 : (_sellableAttribute$va = sellableAttribute.value) === null || _sellableAttribute$va === void 0 ? void 0 : _sellableAttribute$va.key) === ProductKeys.discontinued;
        })
      })];
    });
    return productsWithVariants;
  });

  /**
   * Retrieves related products from Commercetools based on the provided SKUs and filters.
   */
  function fetchRelatedProducts(_x) {
    return _fetchRelatedProducts.apply(this, arguments);
  }
  function _fetchRelatedProducts() {
    _fetchRelatedProducts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var skus, limit, offset;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            skus = _ref.skus, limit = _ref.limit, offset = _ref.offset;
            _context.prev = 1;
            _context.next = 4;
            return client.commercetools.getRelatedProducts.query({
              skus: skus,
              locale: locale,
              country: country,
              currency: currency,
              limit: limit !== null && limit !== void 0 ? limit : PRODUCT_CARDS_CAROUSEL_SLIDES_AMOUNT,
              offset: offset !== null && offset !== void 0 ? offset : 0,
              where: 'masterData(published = "true")'
            });
          case 4:
            relatedProducts.value = _context.sent;
            _context.next = 13;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('skus', skus);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context.t0);
            relatedProducts.value = [];
          case 13:
            return _context.abrupt("return", relatedProducts.value);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7]]);
    }));
    return _fetchRelatedProducts.apply(this, arguments);
  }
  return {
    relatedProducts: relatedProducts,
    availableRelatedProducts: availableRelatedProducts,
    fetchRelatedProducts: fetchRelatedProducts
  };
}